// extracted by mini-css-extract-plugin
export default {"iconContainer":"Subheader_iconContainer__CFgCK","filterSection":"Subheader_filterSection__9zbyZ"};